import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Shield, Activity, Zap } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    icon: <Activity className="w-8 h-8 text-brand-orange" data-id="element-241" />,
    title: 'Step 1: Decompress',
    subtitle: 'Fix the Leaks',
    description: "We start by fixing the hip and ankle 'leaks' that cause knee pain. By restoring range of motion first, we ensure load goes to the muscle, not the joint."
  }, {
    icon: <Shield className="w-8 h-8 text-brand-orange" data-id="element-242" />,
    title: 'Step 2: Armor',
    subtitle: 'Strength-First Hierarchy',
    description: "Slow-tempo strength training that builds muscle with 50% less weight. This creates 'Muscle Armor' around your joints, protecting them from future injury."
  }, {
    icon: <Zap className="w-8 h-8 text-brand-orange" data-id="element-243" />,
    title: 'Step 3: Flush',
    subtitle: 'Metabolic Finishers',
    description: "Low-impact metabolic finishers that burn fat without the 'thud' of running. Get the heart benefits of cardio without the knee tax."
  }];
  return <Section id="solution" background="dark" data-id="element-244">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-245">
        <span className="text-brand-orange font-bold uppercase tracking-widest text-sm mb-2 block" data-id="element-246">
          The Discovery
        </span>
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6 uppercase" data-id="element-247">
          The <span className="text-brand-orange" data-id="element-248">No-Knee Tax</span> Ladder
        </h2>
        <p className="text-xl text-slate-300" data-id="element-249">
          You don't need more intensity. You need a mechanical pivot. A 3-step
          system designed specifically for the mechanics of men over 50.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-250">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-slate-800 -z-10 transform -translate-y-1/2" data-id="element-251"></div>

        {steps.map((step, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.2,
        duration: 0.5
      }} viewport={{
        once: true
      }} className="bg-slate-950 border border-slate-800 p-8 rounded-lg relative hover:border-brand-orange/50 transition-colors group" data-id="element-252">
            <div className="w-16 h-16 bg-slate-900 rounded-full border-2 border-slate-800 flex items-center justify-center mb-6 group-hover:border-brand-orange transition-colors mx-auto md:mx-0 z-10 relative" data-id="element-253">
              {step.icon}
            </div>

            <h3 className="text-2xl font-heading font-bold text-white mb-1 uppercase" data-id="element-254">
              {step.title}
            </h3>
            <p className="text-brand-orange font-medium mb-4 text-sm uppercase tracking-wide" data-id="element-255">
              {step.subtitle}
            </p>
            <p className="text-slate-400 leading-relaxed" data-id="element-256">{step.description}</p>
          </motion.div>)}
      </div>
    </Section>;
}